import React from "react";
import PageShell from "../components/PageShell";
import FAQ from "../components/FAQ";

export default function FAQPage() {
  return (
    <PageShell testId="page-faq">
      <FAQ />
    </PageShell>
  );
}
